import { GET_CENTROS_CENTRO, ADD_CENTRO_CENTRO, REMOVE_CENTRO_CENTRO } from '../constants/action_types';

const initialState = {
    isLoading: true,
    centros: [],
    centroId: 1
};

export default function (state = initialState, action) {

    switch (action.type) {
        case GET_CENTROS_CENTRO:

            return {...state, centroId: action.meta}

        case GET_CENTROS_CENTRO + "_SUCCESS":

            return {
                ...state,
                isLoading: false,
                centros: action.payload.data
            };

        case ADD_CENTRO_CENTRO:

            const newArr = [...state.centros, action.payload];
            return {
                ...state,
                isLoading: false,
                centros: newArr
            };;

        case REMOVE_CENTRO_CENTRO:

            return {
                ...state,
                isLoading: false,
                centros: state.centros.filter(c => c.id !== action.payload.id)
            };

        default:

            return state;
    }
}